export default "__VITE_ASSET__Cadc_zfq__"